import { render, staticRenderFns } from "./QueueImport.vue?vue&type=template&id=f1894a7a&"
import script from "./QueueImport.vue?vue&type=script&lang=js&"
export * from "./QueueImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports